import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import centers from './centers'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        centers,
        base,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
